// components

import AsteriskIcon from 'Icons/components/AsteriskIcon';
import DefaultImageIcon from 'Icons/components/DefaultImageIcon';
import MemoryIcon from 'Icons/components/MemoryIcon';
import MultiImageUploadIcon from 'Icons/components/MultiImageUploadIcon';

import AddIcon from '../components/AddIcon';
import ApprovalIcon from '../components/affiliate/ApprovalIcon';
import ArrowBackIcon from '../components/affiliate/ArrowBackIcon';
import ArrowForwardIcon from '../components/affiliate/ArrowForwardIcon';
import CrownIcon from '../components/affiliate/CrownIcon';
import DashIcon from '../components/affiliate/DashIcon';
import DateIcon from '../components/affiliate/DateIcon';
import FeeIcon from '../components/affiliate/FeeIcon';
import HelpIcon from '../components/affiliate/HelpIcon';
import LoginIcon from '../components/affiliate/LoginIcon';
import LogoutIcon from '../components/affiliate/LogoutIcon';
import NotificationIcon from '../components/affiliate/NotificationIcon';
import RankingIcon from '../components/affiliate/RankingIcon';
import ResetIcon from '../components/affiliate/ResetIcon';
import WithDrawalIcon from '../components/affiliate/WithDrawalIcon';
import AlarmIcon, { AlarmIconVariant } from '../components/AlarmIcon';
import AlbumIcon from '../components/AlbumIcon';
import ArrowIcon, { ArrowIconVariant } from '../components/ArrowIcon';
import AutoPlaySetIcon, { AutoPlaySetIconVariant } from '../components/AutoPlaySetIcon';
import BackgroundIcon from '../components/BackgroundIcon';
import BadgeIcon, { BadgeIconVariant } from '../components/BadgeIcon';
import BgMusicIcon from '../components/BgMusicIcon';
import BookIcon, { BookIconVariant } from '../components/BookIcon';
import BookmarkIcon, { BookmarkIconVariant } from '../components/BookmarkIcon';
import BubbleIcon, { BubbleIconVariantEnum } from '../components/BubbleIcon';
import BubblePickIcon from '../components/BubblePickIcon';
import BubbleSetIcon, { BubbleSetIconVariant } from '../components/BubbleSetIcon';
import CameraIcon from '../components/CameraIcon';
import ChangeIcon from '../components/ChangeIcon';
import CharacterLIcon, { CharacterLIconVariant } from '../components/CharacterLIcon';
import CharacterRIcon, { CharacterRIconVariant } from '../components/CharacterRIcon';
import ChargeStationIcon from '../components/ChargeStationIcon';
import ChatStarIcon from '../components/ChatStarIcon';
import CheckIcon, { CheckIconVariant } from '../components/CheckIcon';
import CheckLargeIcon, { CheckLargeIconVariant } from '../components/CheckLargeIcon';
import ClearRoomIcon from '../components/ClearRoomIcon';
import CloseIcon, { CloseIconVariant } from '../components/CloseIcon';
import CoinIcon, { CoinIconVariant } from '../components/CoinIcon';
import CommentIcon, { CommentIconVariant } from '../components/CommentIcon';
import CommunityEmojiIcon, { CommunityEmojiIconVariant } from '../components/CommunityEmojiIcon';
import CommunityIcon, { CommunityIconVariant } from '../components/CommunityIcon';
import ContestIcon from '../components/ContestIcon';
import ControlIcon from '../components/ControlIcon';
import CreateIcon from '../components/CreateIcon';
import CurrentLocationIcon from '../components/CurrentLocationIcon';
import DefaultUserIcon, { DefaultUserIconVariant } from '../components/DefaultUserIcon';
import DeleteIcon from '../components/DeleteIcon';
import DiceIcon from '../components/DiceIcon';
import DocumentIcon from '../components/DocumentIcon';
import DotIcon from '../components/DotIcon';
import DownloadIcon, { DownloadIconVariant } from '../components/DownloadIcon';
import DownloadTextIcon from '../components/DownloadTextIcon';
import DragIcon from '../components/DragIcon';
import EditIcon from '../components/EditIcon';
import EditProfileCameraIcon from '../components/EditProfileCameraIcon';
import EmailIcon, { EmailIconVariant } from '../components/EmailIcon';
import EqualizerIcon from '../components/EqualizerIcon';
import EventLogoIcon from '../components/EventLogoIcon';
import EyeIcon, { EyeIconVariant } from '../components/EyeIcon';
import FavoriteIcon, { FavoriteIconVariant } from '../components/FavoriteIcon';
import FileIcon from '../components/FileIcon';
import FireIcon from '../components/FireIcon';
import FlipIcon from '../components/FlipIcon';
import FollowerIcon from '../components/FollowerIcon';
import FooterCircleIcon, { FooterCircleIconVariant } from '../components/FooterCircleIcon';
import GifIcon, { GifIconVariant } from '../components/GifIcon';
import GiftIcon, { GiftIconVariant } from '../components/GiftIcon';
import GoTopIcon from '../components/GoTopIcon';
import HashIcon, { HashIconVariant } from '../components/HashIcon';
import HistoryChatBubbleIcon from '../components/HistoryChatBubbleIcon';
import HomeIcon, { HomeIconVariant } from '../components/HomeIcon';
import ImageIcon from '../components/ImageIcon';
import InfoIcon from '../components/InfoIcon';
import LanguageIcon from '../components/LanguageIcon';
import LinkIcon, { LinkIconVariant } from '../components/LinkIcon';
import LoadingIcon from '../components/LoadingIcon';
import LockIcon, { LockIconVariant } from '../components/LockIcon';
import LogoIcon, { LogoIconVariant } from '../components/LogoIcon';
import MailIcon, { MailIconVariant } from '../components/MailIcon';
import MenuIcon, { MenuIconVariant } from '../components/MenuIcon';
import MinusIcon from '../components/MinusIcon';
import ModifyIcon, { ModifyIconVariant } from '../components/ModifyIcon';
import MoreIcon, { MoreIconVariant } from '../components/MoreIcon';
import MoveLargeIcon, { MoveLargeIconVariant } from '../components/MoveLargeIcon';
import MoveSmallIcon, { MoveSmallIconVariant } from '../components/MoveSmallIcon';
import MovieIcon from '../components/MovieIcon';
import MultiImageIcon from '../components/MultiImageIcon';
import MyPageIcon from '../components/MyPageIcon';
import NarrationIcon from '../components/NarrationIcon';
import NarrativeIcon from '../components/NarrativeIcon';
import NewPageIcon from '../components/NewPageIcon';
import OpenIcon from '../components/OpenIcon';
import PasswordIcon from '../components/PasswordIcon';
import PinIcon from '../components/PinIcon';
import PlaySetIcon from '../components/PlaySetIcon';
import PlusIcon from '../components/PlusIcon';
import ProfilePageStatisticsIcon from '../components/ProfilePageStatisticsIcon';
import PromotionBadgeIcon from '../components/PromotionBadgeIcon';
import PushNotificationIcon from '../components/PushNotificationIcon';
import QuestionIcon from '../components/QuestionIcon';
import RadioIcon from '../components/RadioIcon';
import ReactionIcon from '../components/ReactionIcon';
import RemoveIcon from '../components/RemoveIcon';
import ReplyLineIcon from '../components/ReplyLineIcon';
import RewardIcon from '../components/RewardIcon';
import RocketIcon from '../components/RocketIcon';
import RotateIcon from '../components/RotateIcon';
import SceneIcon from '../components/SceneIcon';
import ScrollUpIcon from '../components/ScrollUpIcon';
import SearchIcon from '../components/SearchIcon';
import SelectSmallIcon from '../components/SelectSmallIcon';
import SendEmailIcon from '../components/SendEmailIcon';
import SendIcon from '../components/SendIcon';
import SettingIcon from '../components/SettingIcon';
import ShareSocialIcon from '../components/ShareIcon';
import SignIcon from '../components/SignIcon';
import SocialIcon from '../components/SocialIcon';
import SortIcon from '../components/SortIcon';
import SoundIcon from '../components/SoundIcon';
import SquareIcon from '../components/SquareIcon';
import StarIcon from '../components/StarIcon';
import StatusIcon from '../components/StatusIcon';
import StudioBackgroundIcon from '../components/StudioBackgroundIcon';
import StudioToolIcon from '../components/StudioToolIcon';
import TabIcon from '../components/TabIcon';
import TailIcon from '../components/TailIcon';
import TextIcon from '../components/TextIcon';
import ThemeIcon from '../components/ThemeIcon';
import ThrillIcon from '../components/ThrillIcon';
import ChargeIcon from '../components/tingle/ChargeIcon';
import IncentiveIcon from '../components/tingle/IncentiveIcon';
import { default as TingleLogoIcon } from '../components/tingle/LogoIcon';
import PotionIcon from '../components/tingle/PotionIcon';
import SproutIcon from '../components/tingle/SproutIcon';
import StoreIcon from '../components/tingle/StoreIcon';
import TopIcon from '../components/TopIcon';
import UniverseIcon from '../components/UniverseIcon';
import UpLoadPhotoIcon from '../components/UpLoadPhotoIcon';
import UserIcon from '../components/UserIcon';
import VoteIcon from '../components/VoteIcon';
import WarningIcon from '../components/WarningIcon';
import WritingIcon from '../components/WritingIcon';

// 버블 아이콘
export const CommonIcon = {
  Logo: LogoIcon,
  Bubble: BubbleIcon,
};

export const StudioIcon = {
  ClearRoom: ClearRoomIcon,
  Background: BackgroundIcon,
  Narrative: NarrativeIcon,
  Status: StatusIcon,
  BgMusic: BgMusicIcon,
  AutoPlay: AutoPlaySetIcon,
  Image: ImageIcon,
  Top: TopIcon,
  CurrentLocation: CurrentLocationIcon,
  StudioBackground: StudioBackgroundIcon,
  NewPage: NewPageIcon,
};

export const BubbleChatIcon = {
  Universe: UniverseIcon,
  Scene: SceneIcon,
  Dice: DiceIcon,
  Theme: ThemeIcon,
  Square: SquareIcon,
  MultiImage: MultiImageIcon,
};

export const AffiliateIcon = {
  Approval: ApprovalIcon,
  Dash: DashIcon,
  Date: DateIcon,
  Fee: FeeIcon,
  Login: LoginIcon,
  Logout: LogoutIcon,
  Notification: NotificationIcon,
  Reset: ResetIcon,
  Crown: CrownIcon,
  WithDrawal: WithDrawalIcon,
  Ranking: RankingIcon,
  ArrowForward: ArrowForwardIcon,
  ArrowBack: ArrowBackIcon,
  HelpIcon: HelpIcon,
};

export const TingleIcon = {
  Logo: TingleLogoIcon,
  Store: StoreIcon,
  Incentive: IncentiveIcon,
  Sprout: SproutIcon,
  Potion: PotionIcon,
  Charge: ChargeIcon,
};

// Icon Components
export const Icon = {
  BubblePick: BubblePickIcon,
  Search: SearchIcon,
  Check: CheckIcon,
  Menu: MenuIcon,
  Sort: SortIcon,
  Arrow: ArrowIcon,
  More: MoreIcon,
  Text: TextIcon,
  Plus: PlusIcon,
  Minus: MinusIcon,
  Edit: EditIcon,
  Comment: CommentIcon,
  Change: ChangeIcon,
  Close: CloseIcon,
  Delete: DeleteIcon,
  Home: HomeIcon,
  Language: LanguageIcon,
  MyPage: MyPageIcon,
  Remove: RemoveIcon,
  Rotate: RotateIcon,
  Sign: SignIcon,
  Tab: TabIcon,
  Writing: WritingIcon,
  PlaySet: PlaySetIcon,
  BubbleSet: BubbleSetIcon,
  Create: CreateIcon,
  Drag: DragIcon,
  Equalizer: EqualizerIcon,
  File: FileIcon,
  Info: InfoIcon,
  Open: OpenIcon,
  Setting: SettingIcon,
  Social: SocialIcon,
  Star: StarIcon,
  Mail: MailIcon,
  Modify: ModifyIcon,
  Radio: RadioIcon,
  Favorite: FavoriteIcon,
  PushNotification: PushNotificationIcon,
  Alarm: AlarmIcon,
  Community: CommunityIcon,
  Camera: CameraIcon,
  Album: AlbumIcon,
  ReplyLine: ReplyLineIcon,
  Hash: HashIcon,
  Bookmark: BookmarkIcon,
  MoveSmall: MoveSmallIcon,
  Eye: EyeIcon,
  CharacterR: CharacterRIcon,
  CharacterL: CharacterLIcon,
  Password: PasswordIcon,
  Sound: SoundIcon,
  Download: DownloadIcon,
  DownloadText: DownloadTextIcon,
  Loading: LoadingIcon,
  Warning: WarningIcon,
  UpLoadPhoto: UpLoadPhotoIcon,
  Narration: NarrationIcon,
  Follower: FollowerIcon,
  Contest: ContestIcon,
  Coin: CoinIcon,
  Add: AddIcon,
  Send: SendIcon,
  MoveLarge: MoveLargeIcon,
  GoTop: GoTopIcon,
  Badge: BadgeIcon,
  Email: EmailIcon,
  SendEmail: SendEmailIcon,
  CheckLarge: CheckLargeIcon,
  EditProfileCamera: EditProfileCameraIcon,
  SelectSmall: SelectSmallIcon,
  FooterCircle: FooterCircleIcon,
  ProfilePageStatistics: ProfilePageStatisticsIcon,
  ShareSocial: ShareSocialIcon,
  User: UserIcon,
  StudioTool: StudioToolIcon,
  Rocket: RocketIcon,
  Gift: GiftIcon,
  Book: BookIcon,
  Question: QuestionIcon,
  Fire: FireIcon,
  Dot: DotIcon,
  Reaction: ReactionIcon,
  CommunityEmoji: CommunityEmojiIcon,
  Vote: VoteIcon,
  Movie: MovieIcon,
  Link: LinkIcon,
  Gif: GifIcon,
  Pin: PinIcon,
  Control: ControlIcon,
  HistoryChatBubble: HistoryChatBubbleIcon,
  DefaultUser: DefaultUserIcon,
  Thrill: ThrillIcon,
  Lock: LockIcon,
  Tail: TailIcon,
  PromotionBadge: PromotionBadgeIcon,
  Document: DocumentIcon,
  Reward: RewardIcon,
  ChatStar: ChatStarIcon,
  ChargeStation: ChargeStationIcon,
  ScrollUp: ScrollUpIcon,
  EventLogo: EventLogoIcon,
  Asterisk: AsteriskIcon,
  MultiImageUpload: MultiImageUploadIcon,
  DefaultImage: DefaultImageIcon,
  Flip: FlipIcon,
  Memory: MemoryIcon,
  ...StudioIcon,
  ...CommonIcon,
  ...BubbleChatIcon,
  ...AffiliateIcon,
};
